<app-drawer
  [isOpen]="isOpen"
  [title]="drawerTitle"
  [width]="constants.drawer.documentsWidth"
  [maxWidth]="constants.drawer.maxWidth"
  [showBackdrop]="false"
  (closed)="onDrawerClose()"
>
  @if (form && reportForm) {
    <div class="document-details-drawer">
      <div class="document-details-drawer__content">
        <section class="document-details-drawer__accordion">
          <button
            class="document-details-drawer__accordion-header"
            type="button"
            (click)="toggleProperties()"
          >
            <span class="document-details-drawer__accordion-title">
              <mat-icon class="document-details-drawer__accordion-title-icon">edit</mat-icon>
              <span>{{ 'labels.docProps' | transloco }}</span>
            </span>
            <span class="material-icons-outlined">
              {{ isPropertiesExpanded ? 'expand_less' : 'expand_more' }}
            </span>
          </button>

          @if (isPropertiesExpanded) {
            <div class="document-details-drawer__accordion-body" [formGroup]="form">
              <div class="document-details-drawer__field">
                <div class="document-details-drawer__label">
                  {{ 'labels.docName' | transloco }}
                </div>
                <div class="document-details-drawer__control">
                  <app-input
                    placeholder="{{ 'labels.docName' | transloco }}"
                    formControlName="documentName"
                  ></app-input>
                </div>
              </div>

              <div class="document-details-drawer__field">
                <div class="document-details-drawer__label">
                  {{ 'labels.docLanguage' | transloco }}
                </div>
                <div class="document-details-drawer__control">
                  <app-single-select-autocomplete
                    class="w100"
                    formControlName="languageId"
                    [autocompleteOptions]="contentLanguages"
                    optionLabel="displayName"
                  ></app-single-select-autocomplete>
                </div>
              </div>

              <div
                class="document-details-drawer__field"
                [attr.data-focus-target]="focusFields.DocumentType"
              >
                <div class="document-details-drawer__label">
                  {{ 'labels.docType' | transloco }}
                </div>
                <div
                  class="document-details-drawer__control document-details-drawer__control--with-action"
                >
                  <app-single-select-autocomplete
                    class="w100"
                    formControlName="documentType"
                    [autocompleteOptions]="docTypeItems"
                  ></app-single-select-autocomplete>
                  <app-button
                    *ngIf="canWriteDocuments"
                    class="after-control"
                    [type]="btnTypes.Flat"
                    label="{{ 'labels.createNew' | transloco }}"
                    [size]="btnSizes.Basic"
                    (onClick)="openNewDocTypeForm()"
                  ></app-button>
                </div>
              </div>

              @if (creatingNewDocType && addDocTypeForm) {
                <div class="arrow-up"></div>
                <div class="new-item-form" [formGroup]="addDocTypeForm">
                  <div class="row">
                    <div class="col">
                      {{ 'text.createNewDocType' | transloco }}
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col">
                      <app-input
                        label="{{ 'labels.docType' | transloco }}"
                        placeholder="{{ 'labels.docType' | transloco }}"
                        formControlName="newDocumentType"
                        [id]="'newDocumentType'"
                      ></app-input>
                    </div>
                  </div>
                  <div class="new-item-form__footer">
                    <app-button
                      [type]="btnTypes.Flat"
                      label="{{ 'buttons.add' | transloco }}"
                      [disabled]="addDocTypeForm.invalid"
                      [size]="btnSizes.Basic"
                      (onClick)="onConfirmNewDocType()"
                    ></app-button>
                    <app-button
                      [type]="btnTypes.Stroked"
                      label="{{ 'buttons.cancel' | transloco }}"
                      [size]="btnSizes.Basic"
                      (onClick)="onCancelNewDocType()"
                    ></app-button>
                  </div>
                </div>
              }

              <div
                class="document-details-drawer__field"
                [attr.data-focus-target]="focusFields.Counterparties"
              >
                <div class="document-details-drawer__label">
                  {{ 'labels.counterparties' | transloco }}
                </div>
                <div
                  class="document-details-drawer__control document-details-drawer__control--with-action"
                >
                  <app-multi-select-autocomplete
                    class="w100"
                    formControlName="counterparties"
                    [autocompleteOptions]="conterPartyItems"
                    [hiddenOptions]="hiddenConterPartyItems"
                  ></app-multi-select-autocomplete>
                  <app-button
                    class="after-control"
                    [type]="btnTypes.Flat"
                    label="{{ 'labels.createNew' | transloco }}"
                    [size]="btnSizes.Basic"
                    [disabled]="!canCreateNewCounterparty"
                    (onClick)="openNewPartyForm()"
                  ></app-button>
                </div>
              </div>

              @if (creatingNewParty && addPartyForm) {
                <div class="arrow-up"></div>
                <div class="new-item-form" [formGroup]="addPartyForm">
                  <div class="row">
                    <div class="col">
                      {{ 'text.createNewParty' | transloco }}
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col">
                      <app-input
                        label="{{ 'labels.counterparty' | transloco }}"
                        placeholder="{{ 'labels.counterparty' | transloco }}"
                        formControlName="newPartyName"
                        [id]="'newPartyName'"
                      ></app-input>
                    </div>
                  </div>
                  <div class="new-item-form__footer">
                    <app-button
                      [type]="btnTypes.Flat"
                      label="{{ 'buttons.add' | transloco }}"
                      [disabled]="addPartyForm.invalid"
                      [size]="btnSizes.Basic"
                      (onClick)="onConfirmNewParty()"
                    ></app-button>
                    <app-button
                      [type]="btnTypes.Stroked"
                      label="{{ 'buttons.cancel' | transloco }}"
                      [size]="btnSizes.Basic"
                      (onClick)="onCancelNewParty()"
                    ></app-button>
                  </div>
                </div>
              }

              <div
                class="document-details-drawer__field"
                [attr.data-focus-target]="focusFields.Position"
              >
                <div class="document-details-drawer__label">
                  {{ 'labels.myPosition' | transloco }}
                </div>
                <div class="document-details-drawer__control">
                  <app-radio formControlName="myPosition" [items]="positionItems"></app-radio>
                </div>
              </div>

              <div
                class="document-details-drawer__field"
                [attr.data-focus-target]="focusFields.Status"
              >
                <div class="document-details-drawer__label">
                  {{ 'labels.status' | transloco }}
                </div>
                <div class="document-details-drawer__control">
                  <app-single-select-autocomplete
                    formControlName="status"
                    [autocompleteOptions]="docStatusItems"
                  ></app-single-select-autocomplete>
                </div>
              </div>

              <div
                class="document-details-drawer__field"
                [attr.data-focus-target]="focusFields.Playbook"
              >
                <div class="document-details-drawer__label">
                  {{ 'titles.playbook' | transloco }}
                </div>
                <div class="document-details-drawer__control">
                  <app-single-select-autocomplete
                    class="w100"
                    formControlName="assignedPlaybookId"
                    [autocompleteOptions]="playbookItems"
                    optionLabel="displayName"
                    optionValue="uniqueId"
                  ></app-single-select-autocomplete>
                </div>
              </div>

              @if (canWriteDocuments) {
                <div class="document-details-drawer__actions">
                  <app-button
                    [type]="btnTypes.Flat"
                    label="{{ 'buttons.update' | transloco }}"
                    [disabled]="
                      form.invalid ||
                      !!(isDocumentLoading$ | async) ||
                      !!(isDocumentEditing$ | async)
                    "
                    [size]="btnSizes.Basic"
                    (onClick)="onConfirm()"
                  ></app-button>
                  <app-button
                    [type]="btnTypes.Stroked"
                    [disabled]="!!(isDocumentEditing$ | async)"
                    label="{{ 'buttons.cancel' | transloco }}"
                    [size]="btnSizes.Basic"
                    (onClick)="onCancel()"
                  ></app-button>
                </div>
              }
            </div>
          }
        </section>

        <section
          class="document-details-drawer__accordion document-details-drawer__accordion--versions"
        >
          <button
            class="document-details-drawer__accordion-header"
            type="button"
            (click)="toggleVersions()"
          >
            <span class="document-details-drawer__accordion-title">
              <mat-icon class="document-details-drawer__accordion-title-icon">history</mat-icon>
              <span>{{ 'titles.fileVersions' | transloco }}</span>
            </span>
            <span class="material-icons-outlined">
              {{ isVersionsExpanded ? 'expand_less' : 'expand_more' }}
            </span>
          </button>

          @if (isVersionsExpanded) {
            <div class="document-details-drawer__accordion-body">
              <div class="document-details-drawer__versions-toolbar">
                <div class="document-details-drawer__versions-search">
                  <app-search-input
                    [formControl]="versionSearchControl"
                    [placeholder]="'placeholders.searchVersions' | transloco"
                  ></app-search-input>
                </div>

                <app-button
                  [type]="btnTypes.Flat"
                  [size]="btnSizes.Basic"
                  [disabled]="versionUploadInProgress"
                  [label]="
                    (versionUploadInProgress ? 'text.uploading' : 'buttons.addVersion') | transloco
                  "
                  (onClick)="openVersionUploadPicker(versionFileInput)"
                ></app-button>

                <input
                  #versionFileInput
                  class="document-details-drawer__hidden-file-input"
                  type="file"
                  [accept]="acceptedVersionFileTypes"
                  (change)="onVersionFileSelected($event)"
                />
              </div>

              @if (versionsLoading) {
                <div class="document-details-drawer__versions-empty-state">
                  {{ 'text.loading' | transloco }}
                </div>
              } @else if (versions.length) {
                <div class="document-details-drawer__versions-table-wrap">
                  <app-client-side-data-table
                    [id]="versionsTableId"
                    [selectFieldName]="'versionKey'"
                    [data]="versionTableRows"
                    [columns]="versionColumns"
                    [sort]="versionSort"
                    [eventService]="documentDetailsDrawerVersionsEventsService"
                    [refreshIt]="refreshVersionsTable"
                  ></app-client-side-data-table>
                </div>
              } @else {
                <div class="document-details-drawer__versions-empty-state">
                  {{ 'text.noFileVersions' | transloco }}
                </div>
              }
            </div>
          }
        </section>

        <section
          class="document-details-drawer__accordion"
          [attr.data-focus-target]="focusFields.PlaybookCompliance"
        >
          <button
            class="document-details-drawer__accordion-header"
            type="button"
            (click)="togglePlaybookCompliance()"
          >
            <span class="document-details-drawer__accordion-title">
              <mat-icon class="document-details-drawer__accordion-title-icon">bar_chart</mat-icon>
              <span>{{ 'labels.playbookCompliance' | transloco }}</span>
            </span>
            <span class="document-details-drawer__accordion-header-side">
              @if (isPlaybookComplianceReviewInProgress) {
                <span class="document-details-drawer__header-spinner" aria-hidden="true"></span>
              }
              @if (playbookComplianceReview) {
                <span class="document-details-drawer__compliance-score">
                  {{ playbookComplianceReview.score }}%
                </span>
              }
              <span class="material-icons-outlined">
                {{ isPlaybookComplianceExpanded ? 'expand_less' : 'expand_more' }}
              </span>
            </span>
          </button>

          @if (isPlaybookComplianceExpanded) {
            <div class="document-details-drawer__accordion-body">
              <p class="document-details-drawer__compliance-intro">
                {{ 'text.playbookComplianceDrawerDescription' | transloco }}
              </p>

              @if (showPlaybookSelectionPrompt) {
                <div class="document-details-drawer__playbook-selection-panel">
                  <p class="document-details-drawer__playbook-selection-text">
                    {{ 'text.playbookComplianceSelectPrompt' | transloco }}
                  </p>
                  @if (assignedPlaybookIdControl) {
                    <div class="document-details-drawer__playbook-selection-control">
                      <app-single-select-autocomplete
                        class="w100"
                        [formControl]="assignedPlaybookIdControl"
                        [autocompleteOptions]="playbookItems"
                        optionLabel="displayName"
                        optionValue="uniqueId"
                        placeholderKey="placeholders.selectPlaybook"
                      ></app-single-select-autocomplete>
                    </div>
                  }
                </div>
              }

              @if (showPlaybookComplianceReviewButton) {
                <app-button
                  [type]="btnTypes.Flat"
                  [icon]="'text_compare'"
                  [iconColor]="'currentColor'"
                  label="{{ 'buttons.review' | transloco }}"
                  [disabled]="!canStartPlaybookComplianceReview"
                  (onClick)="startPlaybookComplianceReview()"
                ></app-button>
              }

              @if (isPlaybookComplianceReviewInProgress) {
                <div class="document-details-drawer__loading-state">
                  <div class="document-details-drawer__loading-state-header">
                    <span>{{ 'buttons.reviewing' | transloco }}</span>
                    @if (playbookComplianceReviewProgress !== null) {
                      <span>{{ playbookComplianceReviewProgress }}%</span>
                    }
                  </div>
                  @if (!playbookComplianceReview) {
                    <div class="document-details-drawer__skeleton-wrapper">
                      <div class="document-details-drawer__skeleton-box"></div>
                    </div>
                  }
                </div>
              }

              @if (playbookComplianceReview) {
                <div class="document-details-drawer__flag-summary">
                  <span class="document-details-drawer__flag-summary-label">
                    {{ 'labels.flags' | transloco }}
                  </span>
                  <button
                    type="button"
                    class="document-details-drawer__flag-chip"
                    [class.document-details-drawer__flag-chip--active]="
                      isPlaybookComplianceFlagTypeSelected(flagTypes.MostDesired)
                    "
                    [attr.aria-pressed]="
                      isPlaybookComplianceFlagTypeSelected(flagTypes.MostDesired)
                    "
                    (click)="togglePlaybookComplianceFlagType(flagTypes.MostDesired)"
                  >
                    <mat-icon
                      class="document-details-drawer__flag document-details-drawer__flag--green"
                      >flag</mat-icon
                    >
                    {{ playbookComplianceReview.greenCount }} {{ 'labels.green' | transloco }}
                  </button>
                  <button
                    type="button"
                    class="document-details-drawer__flag-chip"
                    [class.document-details-drawer__flag-chip--active]="
                      isPlaybookComplianceFlagTypeSelected(flagTypes.Fallback)
                    "
                    [attr.aria-pressed]="isPlaybookComplianceFlagTypeSelected(flagTypes.Fallback)"
                    (click)="togglePlaybookComplianceFlagType(flagTypes.Fallback)"
                  >
                    <mat-icon
                      class="document-details-drawer__flag document-details-drawer__flag--orange"
                      >flag</mat-icon
                    >
                    {{ playbookComplianceReview.orangeCount }} {{ 'labels.orange' | transloco }}
                  </button>
                  <button
                    type="button"
                    class="document-details-drawer__flag-chip"
                    [class.document-details-drawer__flag-chip--active]="
                      isPlaybookComplianceFlagTypeSelected(flagTypes.Unacceptable)
                    "
                    [attr.aria-pressed]="
                      isPlaybookComplianceFlagTypeSelected(flagTypes.Unacceptable)
                    "
                    (click)="togglePlaybookComplianceFlagType(flagTypes.Unacceptable)"
                  >
                    <mat-icon
                      class="document-details-drawer__flag document-details-drawer__flag--red"
                      >flag</mat-icon
                    >
                    {{ playbookComplianceReview.redCount }} {{ 'labels.red' | transloco }}
                  </button>
                </div>

                <div class="document-details-drawer__compliance-list">
                  @for (item of filteredPlaybookComplianceItems; track item.id) {
                    <article
                      class="document-details-drawer__compliance-card"
                      [ngClass]="getFlagClass(item.flagType)"
                    >
                      <div class="document-details-drawer__compliance-card-header">
                        <span class="document-details-drawer__compliance-card-title">
                          <mat-icon
                            class="document-details-drawer__flag document-details-drawer__compliance-card-flag"
                            [ngClass]="getFlagClass(item.flagType)"
                            >flag</mat-icon
                          >
                          <span>{{ item.title }}</span>
                        </span>
                        <span
                          class="document-details-drawer__compliance-status"
                          [ngClass]="getComplianceStatusClass(item.flagType)"
                        >
                          {{ getComplianceStatusLabelKey(item.flagType) | transloco }}
                        </span>
                      </div>
                      <p class="document-details-drawer__compliance-explanation">
                        {{ item.explanation }}
                      </p>
                    </article>
                  }
                </div>
              }
            </div>
          }
        </section>

        <section
          class="document-details-drawer__accordion document-details-drawer__accordion--action"
          [attr.data-focus-target]="focusFields.SignatureRequest"
        >
          <button
            class="document-details-drawer__accordion-header document-details-drawer__accordion-header--action"
            type="button"
            (click)="toggleSignatureRequest()"
          >
            <span class="document-details-drawer__accordion-title">
              <mat-icon class="document-details-drawer__accordion-title-icon">draw</mat-icon>
              <span>{{ 'titles.sendForSignature' | transloco }}</span>
            </span>
            <span class="document-details-drawer__accordion-header-side">
              @if (signatureSessionStatusLabelKey) {
                <span class="document-details-drawer__signature-badge">
                  {{ signatureSessionStatusLabelKey | transloco }}
                </span>
              }

              <span class="material-icons-outlined">
                {{ isSignatureRequestExpanded ? 'expand_less' : 'expand_more' }}
              </span>
            </span>
          </button>

          @if (isSignatureRequestExpanded) {
            <div class="document-details-drawer__accordion-body">
              <div class="document-details-drawer__signature-intro">
                {{ 'text.sendForSignatureInfo' | transloco }}
              </div>

              <div class="document-details-drawer__label">
                {{ 'labels.recipients' | transloco }}
              </div>

              <div class="document-details-drawer__signature-recipient-list">
                @for (recipient of signatureRecipients; track recipient.id) {
                  <div class="document-details-drawer__signature-recipient-card">
                    @if (isSignatureRequestReadOnly) {
                      <div
                        class="document-details-drawer__signature-recipient-grid document-details-drawer__signature-recipient-grid--readonly"
                      >
                        <div class="document-details-drawer__signature-recipient-readonly-fields">
                          <div class="document-details-drawer__signature-readonly-field">
                            <div class="document-details-drawer__signature-readonly-label">
                              {{ 'labels.fullName' | transloco }}
                            </div>
                            <div class="document-details-drawer__signature-readonly-value">
                              {{ getSignatureRecipientName(recipient) }}
                            </div>
                          </div>

                          <div class="document-details-drawer__signature-readonly-field">
                            <div class="document-details-drawer__signature-readonly-label">
                              {{ 'labels.emailAddress' | transloco }}
                            </div>
                            <div class="document-details-drawer__signature-readonly-value">
                              {{ getSignatureRecipientEmail(recipient) }}
                            </div>
                          </div>
                        </div>

                        <div class="document-details-drawer__signature-status">
                          @if (isSignatureRecipientCc(recipient)) {
                            <span
                              class="table-menu-icon icon-closed_caption document-details-drawer__signature-status-icon document-details-drawer__signature-status-icon--font"
                              aria-hidden="true"
                            ></span>
                          } @else if (isSignatureRecipientSubscriber(recipient)) {
                            <span
                              class="table-menu-icon icon-signature document-details-drawer__signature-status-icon document-details-drawer__signature-status-icon--font"
                              aria-hidden="true"
                            ></span>
                          } @else {
                            <span
                              class="material-icons-outlined document-details-drawer__signature-status-icon"
                            >
                              {{ getSignatureRecipientStatusIcon(recipient) }}
                            </span>
                          }

                          <div>
                            <div class="document-details-drawer__signature-status-text">
                              {{ getSignatureRecipientStatusText(recipient) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    } @else {
                      <div class="document-details-drawer__signature-recipient-grid">
                        <div class="document-details-drawer__control">
                          <div class="document-details-drawer__signature-readonly-label">
                            {{ 'labels.fullName' | transloco }}
                            <span>*</span>
                          </div>

                          <mat-form-field appearance="outline" class="w100">
                            <input
                              matInput
                              [formControl]="recipient.nameControl"
                              [id]="'signatureRecipientName' + recipient.id"
                              [placeholder]="'placeholders.signatureRecipientName' | transloco"
                              [matAutocomplete]="signatureRecipientNameAutocomplete"
                              autocomplete="off"
                              (blur)="recipient.nameControl.markAsTouched()"
                            />

                            <mat-autocomplete
                              #signatureRecipientNameAutocomplete="matAutocomplete"
                              autoActiveFirstOption
                              (optionSelected)="
                                onSignatureRecipientAutocompleteValueSelected(
                                  recipient,
                                  'name',
                                  $any($event).option.value
                                )
                              "
                            >
                              @for (
                                option of getSignatureRecipientAutocompleteOptions(
                                  recipient,
                                  'name'
                                );
                                track option.id
                              ) {
                                <mat-option [value]="option.name">
                                  <div class="document-details-drawer__signature-readonly-value">
                                    {{ option.name }}
                                  </div>
                                  <div class="document-details-drawer__signature-readonly-label">
                                    {{ option.email }}
                                  </div>
                                </mat-option>
                              }
                            </mat-autocomplete>

                            @if (recipient.nameControl.invalid && recipient.nameControl.touched) {
                              <mat-error>
                                {{
                                  getSignatureRecipientControlErrorMessage(recipient.nameControl)
                                }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>

                        <div
                          class="document-details-drawer__control document-details-drawer__signature-recipient-field--role"
                        >
                          <app-single-select-autocomplete
                            class="w100"
                            [formControl]="recipient.roleControl"
                            [autocompleteOptions]="signatureRecipientRoleOptions"
                            label="{{ 'labels.signingRole' | transloco }}"
                            optionLabel="name"
                            optionValue="id"
                            [refreshCollectionByTranslationEvent]="true"
                          ></app-single-select-autocomplete>
                        </div>

                        <button
                          type="button"
                          class="document-details-drawer__signature-remove"
                          [attr.aria-label]="'buttons.delete' | transloco"
                          [attr.title]="'buttons.delete' | transloco"
                          [disabled]="isPreparingSignatureRequest"
                          (click)="removeSignatureRecipient(recipient.id)"
                        >
                          <span class="table-menu-icon icon-delete" aria-hidden="true"></span>
                        </button>

                        <div
                          class="document-details-drawer__control document-details-drawer__signature-recipient-field--email"
                        >
                          <div class="document-details-drawer__signature-readonly-label">
                            {{ 'labels.emailAddress' | transloco }}
                            <span>*</span>
                          </div>

                          <mat-form-field appearance="outline" class="w100">
                            <input
                              matInput
                              [formControl]="recipient.emailControl"
                              [id]="'signatureRecipientEmail' + recipient.id"
                              [placeholder]="'placeholders.signatureRecipientEmail' | transloco"
                              [matAutocomplete]="signatureRecipientEmailAutocomplete"
                              autocomplete="off"
                              (blur)="recipient.emailControl.markAsTouched()"
                            />

                            <mat-autocomplete
                              #signatureRecipientEmailAutocomplete="matAutocomplete"
                              autoActiveFirstOption
                              (optionSelected)="
                                onSignatureRecipientAutocompleteValueSelected(
                                  recipient,
                                  'email',
                                  $any($event).option.value
                                )
                              "
                            >
                              @for (
                                option of getSignatureRecipientAutocompleteOptions(
                                  recipient,
                                  'email'
                                );
                                track option.id
                              ) {
                                <mat-option [value]="option.email">
                                  <div class="document-details-drawer__signature-readonly-value">
                                    {{ option.name }}
                                  </div>
                                  <div class="document-details-drawer__signature-readonly-label">
                                    {{ option.email }}
                                  </div>
                                </mat-option>
                              }
                            </mat-autocomplete>

                            @if (recipient.emailControl.invalid && recipient.emailControl.touched) {
                              <mat-error>
                                {{
                                  getSignatureRecipientControlErrorMessage(recipient.emailControl)
                                }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>

              @if (!isSignatureRequestReadOnly) {
                <div class="document-details-drawer__signature-controls">
                  <app-button
                    [type]="btnTypes.Stroked"
                    [icon]="'add'"
                    label="{{ 'buttons.addRecipient' | transloco }}"
                    [disabled]="!canAddSignatureRecipient || isPreparingSignatureRequest"
                    [size]="btnSizes.Basic"
                    (onClick)="addSignatureRecipient()"
                  ></app-button>
                </div>

                <div class="document-details-drawer__signature-footer-note">
                  {{ 'text.sendForSignatureRedirectInfo' | transloco }}
                </div>
              } @else if (isSignatureRequestCompleted) {
                <div
                  class="document-details-drawer__signature-footer-note document-details-drawer__signature-footer-note--pending"
                >
                  <span
                    class="material-icons-outlined document-details-drawer__signature-footer-note-icon"
                  >
                    info
                  </span>
                  <span>
                    {{ 'tooltip.documentFullyExecuted' | transloco }}
                  </span>
                </div>
              } @else {
                <div
                  class="document-details-drawer__signature-footer-note document-details-drawer__signature-footer-note--pending"
                >
                  <span
                    class="material-icons-outlined document-details-drawer__signature-footer-note-icon"
                  >
                    info
                  </span>
                  <span>
                    {{ 'tooltip.cancelSigning' | transloco }}
                  </span>
                </div>
              }

              <div
                class="document-details-drawer__actions document-details-drawer__actions--report"
              >
                @if (isSignatureRequestCompleted) {
                  <app-button
                    [type]="btnTypes.Flat"
                    [icon]="'download'"
                    label="{{ 'actions.download' | transloco }}"
                    [size]="btnSizes.Basic"
                    (onClick)="downloadSignedDocument()"
                  ></app-button>
                } @else if (isSignatureRequestPending) {
                  <app-button
                    [type]="btnTypes.Basic_Red"
                    label="{{ 'buttons.cancelSigning' | transloco }}"
                    [size]="btnSizes.Basic"
                    (onClick)="onCancelSignatureRequest()"
                  ></app-button>
                } @else if (signatureSessionStatus) {
                } @else {
                  <app-button
                    [type]="btnTypes.Flat"
                    label="{{ 'buttons.continueToDocusign' | transloco }}"
                    [disabled]="!isSendForSignatureEnabled"
                    [size]="btnSizes.Basic"
                    (onClick)="onSendForSignatureConfirm()"
                  ></app-button>
                }
              </div>
            </div>
          }
        </section>

        @if (canReadReporting) {
          <section
            class="document-details-drawer__accordion document-details-drawer__accordion--action"
            [attr.data-focus-target]="focusFields.Report"
          >
            <button
              class="document-details-drawer__accordion-header document-details-drawer__accordion-header--action"
              type="button"
              (click)="toggleReport()"
            >
              <span class="document-details-drawer__accordion-title">
                <mat-icon class="document-details-drawer__accordion-title-icon">send</mat-icon>
                <span>{{ 'titles.sendReport' | transloco }}</span>
              </span>
              <span class="material-icons-outlined">
                {{ isReportExpanded ? 'expand_less' : 'expand_more' }}
              </span>
            </button>

            @if (isReportExpanded) {
              <div class="document-details-drawer__accordion-body" [formGroup]="reportForm">
                <div class="document-details-drawer__report-intro">
                  {{ 'modalBody.sendReportInfo' | transloco }}
                </div>

                <div class="document-details-drawer__field">
                  <div class="document-details-drawer__label">
                    {{ 'labels.recipients' | transloco }}
                  </div>

                  <div class="document-details-drawer__checkbox-list">
                    <app-checkbox formControlName="sendToMe" id="drawerSendToMe">
                      {{ 'labels.sendToMe' | transloco: { email: currentUser?.email || '' } }}
                    </app-checkbox>
                    <app-checkbox formControlName="sendToOthers" id="drawerSendToOthers">
                      {{ 'labels.sendToOthers' | transloco }}
                    </app-checkbox>
                  </div>

                  @if (isSendToOthers) {
                    <div
                      class="document-details-drawer__control document-details-drawer__control--stacked"
                    >
                      <app-input
                        placeholder="{{ 'placeholders.sendToOthersEmails' | transloco }}"
                        [highlightAsError]="isSendToOthersEmailsInvalid"
                        formControlName="sendToOthersEmails"
                      ></app-input>
                    </div>
                  }
                </div>

                <div class="document-details-drawer__field">
                  <div class="document-details-drawer__label">
                    {{ 'labels.reportContent' | transloco }}
                  </div>

                  <div class="document-details-drawer__checkbox-list">
                    <app-checkbox formControlName="reportContentSummary" id="drawerReportSummary">
                      {{ 'labels.summary' | transloco }}
                    </app-checkbox>
                    <app-checkbox
                      formControlName="reportContentPlaybookAnalysis"
                      id="drawerReportPlaybookAnalysis"
                    >
                      {{ 'labels.playbookAnalysis' | transloco }}
                    </app-checkbox>
                  </div>

                  @if (isPlaybookAnalysisSelected) {
                    <div class="document-details-drawer__report-group">
                      <div class="document-details-drawer__report-group-title">
                        {{ 'text.playbookRequiredTitle' | transloco }}
                      </div>

                      <div class="document-details-drawer__report-group-text">
                        {{ 'text.playbookRequiredDescription' | transloco }}
                      </div>

                      <div class="document-details-drawer__report-group-select">
                        <app-single-select-autocomplete
                          class="w100"
                          formControlName="selectedPlaybookId"
                          [autocompleteOptions]="reportPlaybookOptions"
                          optionLabel="displayName"
                          optionValue="uniqueId"
                        ></app-single-select-autocomplete>
                      </div>

                      <!-- @if (hasSelectedReportPlaybook) {
                      <div class="document-details-drawer__selected-playbook">
                        {{ 'text.playbookSelectedForAnalysis' | transloco: { name: selectedReportPlaybookLabel } }}
                      </div>
                    } -->

                      <div
                        class="document-details-drawer__checkbox-list document-details-drawer__checkbox-list--nested"
                        [ngClass]="{
                          'document-details-drawer__checkbox-list--disabled':
                            !hasSelectedReportPlaybook
                        }"
                      >
                        <app-checkbox
                          formControlName="reportContentPlaybookCompliance"
                          id="drawerReportPlaybookCompliance"
                        >
                          {{ 'labels.playbookCompliance' | transloco }}
                        </app-checkbox>
                        <app-checkbox
                          formControlName="reportContentKeyQuestions"
                          id="drawerReportKeyQuestions"
                        >
                          {{ 'labels.keyQuestions' | transloco }}
                        </app-checkbox>
                      </div>
                    </div>
                  }

                  <div class="document-details-drawer__checkbox-list">
                    <app-checkbox
                      formControlName="reportContentIntegrityCheck"
                      id="drawerReportIntegrityCheck"
                    >
                      {{ 'labels.integrityCheck' | transloco }}
                    </app-checkbox>
                    <app-checkbox
                      formControlName="reportContentRegulatoryCompliance"
                      id="drawerReportRegulatoryCompliance"
                    >
                      {{ 'labels.regulatoryCompliance' | transloco }}
                    </app-checkbox>
                    <app-checkbox
                      formControlName="reportContentReadabilityAnalysis"
                      id="drawerReportReadabilityAnalysis"
                    >
                      {{ 'labels.readabilityAnalysis' | transloco }}
                    </app-checkbox>
                  </div>

                  @if (
                    reportForm.hasError('reportContentRequired') &&
                    (reportForm.dirty || reportForm.touched)
                  ) {
                    <div class="document-details-drawer__error-text">
                      {{ 'errors.selectAtLeastOneReportContent' | transloco }}
                    </div>
                  }
                </div>

                <div class="document-details-drawer__field">
                  <div class="document-details-drawer__label">
                    {{ 'labels.reportFormat' | transloco }}
                  </div>
                  <div class="document-details-drawer__control">
                    <app-radio formControlName="reportFormat" [items]="reportFormats"></app-radio>
                  </div>
                </div>

                @if (canWriteReporting) {
                  <div
                    class="document-details-drawer__actions document-details-drawer__actions--report"
                  >
                    <app-button
                      [type]="btnTypes.Flat"
                      label="{{ 'actions.sendReport' | transloco }}"
                      [disabled]="!isSendReportFormValid || !!(isSendingReport$ | async)"
                      [size]="btnSizes.Basic"
                      (onClick)="onSendReportConfirm()"
                    ></app-button>
                  </div>
                }
              </div>
            }
          </section>
        }
      </div>
    </div>
  } @else {
    <div class="document-details-drawer__loading">
      {{ 'text.loading' | transloco }}
    </div>
  }
</app-drawer>

@if (docusignUrl) {
  <div class="document-details-drawer__docusign-overlay">
    <iframe
      class="document-details-drawer__docusign-iframe"
      [src]="docusignUrl"
      [title]="'text.docusignSenderViewTitle' | transloco"
      (load)="onDocusignIframeLoad($event)"
    ></iframe>
  </div>
}
